import { render, staticRenderFns } from "./SizeSelect_1.vue?vue&type=template&id=acebca12&scoped=true&"
import script from "./SizeSelect_1.vue?vue&type=script&lang=js&"
export * from "./SizeSelect_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acebca12",
  null
  
)

export default component.exports